import { ITEMS_PER_PAGE } from './constants'

export function growth(ms) {
  var r = 0.00006
  return Math.floor(100 * Math.pow(Math.E, r * ms))
}

export function getPaginatedData(data, page) {
  return data.slice((-1 + page) * ITEMS_PER_PAGE, page * ITEMS_PER_PAGE)
}

export function getMsPassed(startDate, endDate) {
  if (!startDate) return 0

  if (!endDate) return new Date() - new Date(startDate)

  return new Date(endDate).getTime() - new Date(startDate).getTime()
}

export function formatResult(result) {
  return `${(result / 100).toFixed(2)}x`
}

export function capitalize(string) {
  return string.charAt(0).toUpperCase() + string.slice(1)
}

export function clear(ctx) {
  ctx.clearRect(0, 0, ctx.canvas.width, ctx.canvas.height)
}

export function stepValues(x) {
  let c = 0.4
  let r = 0.1
  while (true) {
    if (x < c) return r

    c *= 5
    r *= 2

    if (x < c) return r
    c *= 2
    r *= 5
  }
}

export function numberWithCommas(x) {
  const formatted = Math.floor((x / 100) * 100) / 100
  return formatted.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',')
}

export function dateToClock(dateObj) {
  const date = new Date(dateObj)
  const h = date.getHours()
  const m = date.getMinutes()

  return `${addZero(h)}:${addZero(m)}`

  function addZero(i) {
    if (i < 10) return `0${i}`
    return i
  }
}

export function winProb(payout) {
  if (payout < 101) {
    return null
  }
  return (9900 / (101 * (payout - 1))) * 100
}

export function generatePassword() {
  let result = ''
  const characters =
    'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789'
  for (let i = 0; i < 10; i++) {
    result += characters.charAt(Math.floor(Math.random() * characters.length))
  }
  return result
}
